module.exports = __webpack_public_path__ + "static/media/JosefinSans-Italic.40b679ec.ttf";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fonts/JosefinSans-Italic.ttf
// module id = 3229
// module chunks = 70